var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-form',{attrs:{"user":_vm.user,"roles":_vm.roles,"saveLoading":_vm.saveLoading},on:{"save":function($event){return _vm.saveUser()}}})}
var staticRenderFns = []

export { render, staticRenderFns }